import { RootState } from '../../rootReducer'
import { ApiStages } from '../../services/api/apiStages'
import { createSelector } from 'reselect'

const stageSelector = (state: RootState) => state.globalSearch.fetchSearch.stage

export const getIsLoading = createSelector([stageSelector], (stage) => {
  return stage === ApiStages.PENDING
})
